export class StripeCheckout {
    static instance = (function () {
        let instance;
        return () => {
            if (!instance)
                instance = new StripeCheckout(process.env.REACT_APP_STRIPE_PUBLIC);
            return instance;
        };
    })();

    constructor(key) {
        if (window.StripeCheckout) {
            this.initialize(key)
        } else {
            document.querySelector('#stripe-checkout').addEventListener('load', () => {
                this.initialize(key)
            });
        }
    }

    initialize(key) {
        this.instance = window.StripeCheckout.configure({
            key:    key,
            image:  '/pg.logo.png',
            token:  (token) => {
                this.promise.resolve(token.id);
                delete this.promise;
            },
            closed: () => {
                if (this.promise) {
                    this.promise.reject();
                    delete this.promise;
                }
            }
        });
    }

    createChargeToken(charge) {
        return new Promise((resolve, reject) => {
            this.promise = {resolve, reject};
            this.instance.open(charge)
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services.js